module.exports = __webpack_public_path__ + "static/media/agrega despacho slice.b07d7c61.png";